import React, { useCallback, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  getVideoDetails,
  updateVideoDetails,
} from "../../../api/functions/video.api";
import styles from "../../../styles/components/video.module.scss";
import { Box, Button, Dialog } from "@mui/material";
import assest from "../../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import SubmitterDetails from "../components/SubmitterDetails";

import { useNavigate } from "react-router-dom";
import ApiLoader from "../../Loaders/ApiLoader";
import CopyrightOwnerships from "../components/CopyrightOwnerships";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndImagePath,
  concatHostAndVideoPath,
  openInNewTab,
  roleFinderTwo,
} from "../../../lib/functions/utils.lib";
import SubmissionInformation from "../components/SubmissionInformation";

import VideoDetailsPending from "../components/VideoDetailsPending";
import HlsPalyer from "../components/HlsPlayer";
import ShowVideoStatus from "../components/ShowVideoStatus";
import HandleVideo from "../components/HandleVideo";
import { getNote } from "../../../api/functions/note.api";
import AdminNotes from "../components/AdminNotes";
import PurchaseInformation from "../components/PurchaseInformation";
import BuyerHandleVideo from "../components/BuyerHandleVideo";
import UserMultipleVideoSubmission from "../components/UserMultipleVideoSubmission";
import VideoMessageSection from "../components/VideoMessageSection";
import VideoReleaseModal from "../../VideoReleaseModal/VideoReleaseModal";
import SuccessfullModal from "../components/modals/SuccessfullModal";
import CopyRightDisputeModal from "../../CopyRightDisputeModal/CopyRightDisputeModal";
import { getCookie } from "../../../lib/functions/storage.lib";

const VideoPageFullModal = ({ open, onClose, id, className }) => {
  const navigate = useNavigate();

  const userCookie = getCookie("userdetails");
  let user = JSON.parse(userCookie ? userCookie : "{}");
  // console.warn("user///////////", user);

  const [bought, setBought] = useState(false);
  // console.warn("bought", bought);
  const {
    data,
    isLoading: isLoadingGet,
    refetch: refetchVideo,
    isRefetching: isRefetchingVideo,
  } = useQuery(
    ["video_details", id],
    async () => getVideoDetails(id, roleFinderTwo(user.role_id)),
    {
      enabled: id && open ? true : false,

      onSuccess: (data) => {
        // console.warn("data2", data);
        if (data.buyer) {
          setBought(true);
        } else {
          setBought(false);
        }
      },
    }
  );
  const {
    data: notes,
    isLoading: notesLoading,
    refetch: refetchNote,
  } = useQuery(["video_notes_details", id], async () => getNote(id), {
    enabled: id && open ? true : false,
  });

  // console.warn("video---data", data);
  // console.warn("isLoadingGet", isLoadingGet, isRefetchingVideo);
  // console.warn("note", notes);

  const [openApprove, setOpenApprove] = React.useState(false);
  const handleClickOpenApprove = () => {
    setOpenApprove(true);
  };
  const handleCloseApprove = () => {
    setOpenApprove(false);
  };

  /***************ProceedModal*****************/

  const [openProceed, setOpenProceed] = React.useState(false);
  const handleClickOpenProceed = () => {
    setOpenProceed(true);
  };
  const handleCloseProceed = () => {
    setOpenProceed(false);
  };

  /***************DenydModal*****************/

  const [openDeny, setOpenDeny] = React.useState(false);
  const handleClickOpenDeny = () => {
    setOpenDeny(true);
  };
  const handleCloseDeny = () => {
    setOpenDeny(false);
  };

  /***************VideoReleasedModal*****************/

  const [openVideoRelease, setOpenVideoRelease] = React.useState(false);
  const handleClickOpenVideoRelease = () => {
    setOpenVideoRelease(true);
  };
  const handleCloseVideoRelease = () => {
    setOpenVideoRelease(false);
  };

  /*****************************release video modal***************************/

  const [openCopyRightDispute, setOpenCopyRightDispute] = React.useState(false);
  const handleClickOpenCopyRightDispute = () => {
    setOpenCopyRightDispute(true);
  };
  const handleCloseCopyRightDispute = () => {
    setOpenCopyRightDispute(false);
  };

  const [succesUpdate, setSuccesUpdate] = useState();
  // console.warn("succesUpdate", succesUpdate);

  const { mutate, isLoading } = useMutation(updateVideoDetails, {
    onSuccess: async (data) => {
      // console.warn("data", data);
      setSuccesUpdate(data.status);
      refetchVideo();
      refetchNote();
    },
    onError: () => {
      console.warn("there was an error");
    },
  });

  const handleUpdate = (status) => {
    mutate({ id: data.id, status });
  };

  const closeSuccess = useCallback(() => {
    setSuccesUpdate(0);
  }, []);

  const [released, setReleased] = useState(false);

  useEffect(() => {
    if (data?.published == 2) {
      setReleased(true);
    }
  }, [data]);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={className}
      >
        <Box className={styles.VideoPageScroll}>
          <ApiLoader
            // loading={notesLoading || isLoadingGet || isRefetchingVideo}
            loading={notesLoading || isLoadingGet}
          />

          <SuccessfullModal
            succesUpdate={succesUpdate}
            onClose={closeSuccess}
          />
          {/* released video portion */}
          <Dialog
            open={released}
            onClose={() => setReleased(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="CopyRightDisputeModal"
          >
            <CopyRightDisputeModal data={data} />
          </Dialog>

          {data && (
            <>
              <Box className={styles.videoWrapper}>
                <Box className={styles.videoWrapperLeft}>
                  <Box className={styles.videoLeftScroll}>
                    <PerfectScrollbar>
                      <Box className="VideocommonBox">
                        <Box className={styles.videoSection}>
                          <Box className={styles.videoBox}>
                            <HlsPalyer
                              source={concatHostAndVideoPath(
                                data.converted_url
                              )}
                            />
                          </Box>
                          <Box className={styles.videoInput}>
                            <input
                              type="text"
                              disabled
                              placeholder={concatDownloadPath(data.video)}
                            />
                            <Button
                              onClick={() =>
                                clipCopy(concatDownloadPath(data.video))
                              }
                            >
                              <img
                                src={assest.copyIcon}
                                width={13}
                                height={16}
                                alt=""
                              />
                            </Button>
                          </Box>

                          {bought ? (
                            <>
                              <BuyerHandleVideo
                                data={data}
                                handleUpdate={handleUpdate}
                              />
                            </>
                          ) : (
                            <HandleVideo
                              data={data}
                              handleUpdate={handleUpdate}
                            />
                          )}

                          <VideoMessageSection data={data} />

                          <Box className={styles.downloadButton}>
                            <Button
                              onClick={() =>
                                openInNewTab(concatDownloadPath(data.video))
                              }
                            >
                              <img
                                src={assest.doenloadVideoicon}
                                width={13}
                                height={14}
                                alt=""
                              />{" "}
                              Download Video
                            </Button>
                            <Button>
                              <img
                                src={assest.downloadAssignment}
                                width={14}
                                height={14}
                                alt=""
                              />{" "}
                              Download Redacted Agreement
                            </Button>
                            {data.status == 1 && (
                              <Button
                                className={styles.releaseButton}
                                onClick={handleClickOpenVideoRelease}
                              >
                                <img
                                  src={assest.releaseVideoIcon}
                                  width={14}
                                  height={14}
                                  alt=""
                                />{" "}
                                Release Video
                              </Button>
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {!bought ? (
                        <VideoDetailsPending
                          refetchVideo={refetchVideo}
                          data={data}
                        />
                      ) : (
                        <>
                          <Box className={styles.purchedBox}>
                            <p>
                              Asset Was Purchased on behalf of ViralSnare by:{" "}
                              <span> {data.buyer?.name} </span>{" "}
                              <span className={styles.purchedBoxSpan}>
                                (Content Buyer)
                              </span>
                            </p>
                          </Box>
                        </>
                      )}
                    </PerfectScrollbar>
                  </Box>
                </Box>

                <Box className={styles.videoWraperRight}>
                  <Box className={styles.videoRightScroll}>
                    <PerfectScrollbar>
                      <Box className={styles.videoOwner}>
                        <ShowVideoStatus
                          notes={notes}
                          data={data}
                          handleUpdate={handleUpdate}
                          refetchNote={refetchNote}
                          onClose={onClose}
                        />
                        {/* <SubmissionUser /> */}
                        {data.otherUploadedVideos?.length > 0 && (
                          <UserMultipleVideoSubmission
                            data={data}
                            refetchVideo={refetchVideo}
                          />
                        )}
                        <SubmitterDetails hideCross data={data} />
                        {bought ? (
                          <VideoDetailsPending
                            refetchVideo={refetchVideo}
                            data={data}
                          />
                        ) : (
                          <CopyrightOwnerships data={data} />
                        )}
                      </Box>
                      {bought ? (
                        <>
                          <PurchaseInformation data={data} />
                        </>
                      ) : (
                        <>
                          <SubmissionInformation data={data} />
                        </>
                      )}
                      {/* {bought && (
                        <AdminNotes
                          data={data}
                          notes={notes}
                          refetchNote={refetchNote}
                        />
                      )}
                      {data?.status == 1 && !bought && ( */}
                      <AdminNotes
                        data={data}
                        notes={notes}
                        refetchNote={refetchNote}
                      />
                      {/* )} */}
                    </PerfectScrollbar>
                  </Box>
                </Box>
              </Box>
              {/* </PerfectScrollbar> */}
            </>
          )}
        </Box>
      </Dialog>
    </>
  );
};

export default VideoPageFullModal;
